import { MenuState } from '@/flightpath-components/models/enums/Menu';
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ name: 'menu' })
export default class MenuStore extends VuexModule {
  menuState: Array<string> = [MenuState.Main];
  machineMenuState = '';
  drawer = false;

  loadingMachines = false;
  loadingMissions = false;

  @Mutation
  setLoadingMachines(state: boolean) {
    this.loadingMachines = state;
  }

  @Mutation
  setLoadingMissions(state: boolean) {
    this.loadingMissions = state;
  }

  @Mutation
  setDrawer(value: boolean): void {
    this.drawer = value;
    if (!this.drawer) this.menuState = [MenuState.Main];
  }

  @Mutation
  pushMenuState(state: string) {
    if (!this.menuState.includes(state)) this.menuState.push(state);
  }

  @Mutation
  popMenuState() {
    if (this.menuState.length > 1) this.menuState.pop();
  }

  @Mutation
  setMachineMenuState(state: string) {
    this.machineMenuState = state;
  }
  @Mutation
  resetMachineMenuState() {
    this.menuState = [MenuState.Main];
  }
  @Mutation
  setupMachineMenuState() {
    this.menuState = [MenuState.Main, MenuState.Machines, MenuState.MachineSelected];
    this.drawer = true;
  }

  get currentMenuState(): string {
    return this.menuState[this.menuState.length - 1];
  }
}
